import { parsePhoneNumber } from 'react-phone-number-input';

/**
 * Add norwegian country code to phone number if it is missing,
 * transform prefix 00 to +, and remove whitespace
 *
 * @param phoneNr
 * @returns phoneNr with country code prefix and without whitespace as string
 */
export function toPhoneNrWithCountryCode(phoneNr: string | undefined | null): string {
  phoneNr = phoneNr?.replace(/\s/g, '') ?? ''; // Remove whitespace if phoneNr is defined
  if (!phoneNr) return '';

  const phoneNrType = parsePhoneNumber(phoneNr, 'NO');
  if (phoneNrType) {
    return phoneNrType.number;
  }
  return '';
}
